import React from 'react';

import { AboutRender } from './AboutRender';

export const About = ():JSX.Element => {
	return (
		<AboutRender/>
	);
};
